export default __webpack_public_path__ + "static/media/002-homechildren.731ac583.svg";